// Libs
import React, { useEffect, useState, useContext, useRef } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

// Comps
import { time } from 'console'

import { alphaHex } from '../../utils'
import { Context as ModalsContext } from '../../context/Modals'

const Container = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 100;

  .modal-scroll-box {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: ${alphaHex('#E5E6EB', 0.6)};
    overflow-x: hidden;
    overflow-y: auto;
  }

  &.dark {
    .modal-scroll-box {
      background: ${alphaHex('#2C2D35', 0.9)};
    }
  }

  .background-events {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
  }
`

// Props
export interface Props {
  backgroundStyles?: React.CSSProperties
  className?: string
  close?: () => void
  keepBodyLocked?: boolean
  lockBody?: boolean
  mobileOnly?: boolean
  retainPointerEvents?: boolean
  style?: React.CSSProperties
  zIndex?: number
}

// Modal
export const Modal: React.FC<Props> = (props) => {
  // Props
  const { backgroundStyles, children, className, close } = props

  // Global State
  const { modalSearchClass } = useContext(ModalsContext)

  // Funcs
  const theOnClose = () => {
    if (close) {
      close()
    } else {
      console.warn('@modal->close: no func set')
    }
  }

  // ..
  return ReactDOM.createPortal(
    <Container className={`${className || ''} ${modalSearchClass}`}>
      <div className="modal-scroll-box" style={{ ...backgroundStyles }}>
        <div className="background-events" onClick={theOnClose} />
        {children}
      </div>
    </Container>,
    document?.body,
  )
}
